export const STATUS = {
    COMPLETED: 'Completed',
    ERROR: 'Error',
    IN_PROCESS: 'In Process',
    INVALID_REQUEST: 'invalid_request',
    OK: 'ok',
    PENDING: 'Pending',
}
